import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AniComponent } from './ani.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { AddAniComponent } from './add-ani/add-ani.component';
import { EditAniComponent } from './edit-ani/edit-ani.component';

@NgModule({
    declarations: [
        AniComponent,
        AddAniComponent,
        EditAniComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [AniComponent]
})
export class AniModule { }
